import { apiFetch } from "./api";

export interface StandardInclusionRow {
  standardInclusionId: number;
  name: string;
  bodyText: string;
  sortOrder: number;
  isDefault: boolean;
  isActive: boolean;
  rowVersionBase64: string | null;
}

export interface StandardInclusionPage {
  rows: StandardInclusionRow[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateStandardInclusionBody {
  name: string;
  bodyText: string;
  sortOrder: number;
  isDefault: boolean;
  isActive: boolean;
}
export type UpdateStandardInclusionBody = CreateStandardInclusionBody;

export const quoteInclusionsAdminApi = {
  listAdmin: (q: string, includeInactive = false, page = 1, pageSize = 50): Promise<StandardInclusionPage> =>
    apiFetch<StandardInclusionPage>(
      `/api/quote-inclusions/admin?page=${page}&pageSize=${pageSize}&includeInactive=${includeInactive}${q ? `&q=${encodeURIComponent(q)}` : ""}`,
    ),
  listActive: (): Promise<StandardInclusionRow[]> =>
    apiFetch<StandardInclusionRow[]>("/api/quote-inclusions"),
  create: (body: CreateStandardInclusionBody): Promise<StandardInclusionRow> =>
    apiFetch<StandardInclusionRow>("/api/quote-inclusions", { method: "POST", body: JSON.stringify(body) }),
  update: (id: number, body: UpdateStandardInclusionBody, rowVersionBase64: string | null): Promise<StandardInclusionRow> =>
    apiFetch<StandardInclusionRow>(`/api/quote-inclusions/${id}`, {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: rowVersionBase64 ? { "If-Match": rowVersionBase64 } : {},
    }),
  remove: (id: number, rowVersionBase64: string | null): Promise<void> =>
    apiFetch<void>(`/api/quote-inclusions/${id}`, {
      method: "DELETE",
      headers: rowVersionBase64 ? { "If-Match": rowVersionBase64 } : {},
    }),
};
